<template>
  <div class="structure">
    <h1>组织机构</h1>
    <img :src="imgUrl.replace('s_', '')" alt="" srcset="">
  </div>
</template>

<script>
import { postDetail } from "@/api/company";

export default {
  name: "structure",
  data() {
    return {
      imgUrl: ''
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    // 详情
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        // this.imgUrl = res.data.organization_pic
        this.imgUrl = res.data.organization_pic
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>